'use strict';

import BaseService from './base.service';

const RoleNamesTranslations = {
    admin: 'Administrador',
    operator: 'Operador',
    vouchers: 'Vales',
    vouchercollector: 'Rendir vales'
};

class UsersService extends BaseService {
    /* @ngInject */
    constructor(SegaUser) {
        super(SegaUser);
    }

    invite(data = {}) {
        return this.Model.invite({
            email: data.email
        }).$promise;
    }

    isInviteValid(opts = {token: ''}) {
        return this.Model.isInviteValid({
            token: opts.token
        }).$promise;
    }

    signup(opts = {token: '', password: '', inviteId: 0}) {
        return this.Model.signup({
            token: opts.token,
            password: opts.password,
            inviteId: opts.inviteId
        }).$promise;
    }

    login(opts = {email: '', password: ''}) {
        return this.Model.login(opts).$promise;
    }

    changePassword(opts = {}) {
        return this.Model.changePassword(opts).$promise;
    }

    resetPassword(opts = {email: ''}) {
        return this.Model.resetPassword({
            email: opts.email
        }).$promise;
    }

    updatePassword(opts = {newPassword: ''}) {
        return this.Model.updatePassword({
            newPassword: opts.newPassword
        }).$promise;
    }

    getAllRoles() {
        return this.Model.getAllRoles().$promise.then(
            (roles) => roles.map(
                r => Object.assign(r, {
                    translatedName: RoleNamesTranslations[r.name]
                })
            )
        );
    }

    addRole(userId, roleId) {
        return this.Model.addRole({
            userId, roleId
        }).$promise;
    }

    removeRole(userId, roleId) {
        return this.Model.removeRole({
            userId, roleId
        }).$promise;
    }

    translateRoleName(name) {
        return RoleNamesTranslations[name];
    }
}

export default UsersService;
